import { action, computed, observable, toJS } from 'mobx'
import {
  ProductType,
  Product,
  Graveyard,
  FuneralHome,
  OfferInput,
  FuneralType,
  Interest,
  Package
} from 'src/resources'
import backend from 'src/api'

import _ = require('lodash')

export default class CatalogueStore {
  @observable private obsProducts: Map<ProductType, Product[]>

  @observable private obsGraveyards: Graveyard[]

  @observable private obsFuneralHome: FuneralHome

  @observable private obsInterests: Interest[]

  @observable private obsPackages: Package[]

  constructor() {
    this.obsProducts = new Map<ProductType, Product[]>()
    this.obsGraveyards = []
    this.obsFuneralHome = null
    this.obsInterests = []
  }

  init(offer: OfferInput) {
    // TODO split up the thens
    return this.fetchCatalogue(offer.uuid, offer.funeralType)
      .then(() => this.fetchFuneralTypes(offer.uuid))
      .then(() => this.fetchFuneralHome(offer.uuid))
      // .then(() => this.fetchGraveyards(offer.funeralType))
      .then(() => this.fetchInterests(offer.uuid))
      .then(() => this.fetchPackages(offer.uuid))
  }

  @computed get isGraveyardsLoaded() {
    return !!this.obsGraveyards.length
  }

  @computed get isFuneralHomeLoaded() {
    return !!this.obsFuneralHome
  }

  @computed get isLoaded() {
    return (
      !!this.obsProducts.size &&
      !!this.obsGraveyards.length &&
      this.isFuneralHomeLoaded &&
      !!this.obsInterests.length
    )
  }

  isProductLoaded(productType?: ProductType) {
    if (!productType) return !!this.obsProducts.size
    return !!this.obsProducts.get(productType).length
  }

  @computed get products() {
    return toJS(this.obsProducts)
  }

  @computed get graveyards() {
    return toJS(this.obsGraveyards)
  }

  @computed get funeralHome() {
    return toJS(this.obsFuneralHome)
  }

  @computed get interests() {
    return toJS(this.obsInterests)
  }

  @computed get packages() {
    return toJS(this.obsPackages)
  }

  getProductsByType(type: ProductType) {
    return this.products[type]
  }

  @action fetchCatalogue(uuid: string, funeralType: FuneralType) {
    const productTypes: ProductType[] = [
      'CEREMONY_OTHER',
      'COFFIN',
      'COFFIN_LINING',
      'FLOWER',
      'URN',
      'CEREMONY',
      'MEMORIAL',
      'CARD',
      'OBITUARY',
      'OTHERS',
      'TOMBS'
    ]
    const newProducts = this.obsProducts
    return backend.findProductsByTypes(
      productTypes,
      funeralType,
      uuid,
      (result) => {
        productTypes.forEach((type) => {
          const resSorted: Product[] = _.orderBy(
            result[type],
            ['orderPriority', 'prices[0].amount'],
            ['desc', 'asc']
          )
          newProducts.set(type, resSorted)
        })
        this.obsProducts = newProducts
      }
    )
  }

  @action fetchFuneralTypes(uuid: string) {
    const newProducts = this.obsProducts
    return backend.findProducts('FUNERAL', uuid, (result) => {
      const resSorted: Product[] = _.orderBy(
        result,
        ['orderPriority', 'prices[0].amount'],
        ['desc', 'asc']
      )
      newProducts.set('FUNERAL', resSorted)
      this.obsProducts = newProducts
    })
  }

  @action fetchInterests(uuid: string) {
    return backend.findInterests(uuid, (result) => {
      this.obsInterests = result.findInterests
    })
  }

  @action fetchPackages(uuid: string) {
    return backend.findPackages(uuid, (result) => {
      this.obsPackages = result.findPackages
    })
  }

  @action fetchFuneralHome(uuid: string) {
    return backend.findFuneralHomeInfo(uuid, (result) => {
      const funeralHomeInfo = result.fetchFuneralHomeInfo
      if (funeralHomeInfo && funeralHomeInfo.name) {
        this.obsFuneralHome = funeralHomeInfo
      }
    })
  }

  @action fetchGraveyards = (funeralType: FuneralType, centerLat: string, centerLong: string) => {
    return backend.findAvailableGraveyards(funeralType, centerLat, centerLong, (result) => {
      this.obsGraveyards = result
    })
  }
}



// WEBPACK FOOTER //
// ./src/stores/CatalogueStore.ts